<!-- ============================================================
     Error page — Cordell styling
     Replaces error.component.html
     ============================================================ -->

<div class="cc-error">
  <header class="cc-error__appbar">
    <span class="cc-error__mark">CC</span>
    <span class="cc-error__type">
      <span class="cc-error__name">Cordell &amp; Cordell</span>
      <span class="cc-error__sub">Divorce &amp; Family Law</span>
    </span>
  </header>

  <div class="cc-error__body">
    <div class="cc-error__icon">!</div>
    <span class="cc-error__eyebrow">Link Problem</span>
    <h1 class="cc-error__title">This scheduling link isn't valid</h1>
    <p class="cc-error__message">{{ errorMessage }}</p>
    <p class="cc-error__help">
      The link may have expired or already been used. Request a new link from
      your attorney's office, or call us and we'll help you book.
    </p>
    <a class="cc-error__cta" href="tel:18338254388">Call (833) 825-4388</a>
  </div>
</div>
